import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import BotFlowsAPI from '../../api/botFlows';
import { throwErrorMessage } from '../utils/api';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isFetchingItem: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
    isActivating: false,
  },
};

export const getters = {
  getBotFlows($state) {
    return $state.records;
  },
  getBotFlow: $state => id => {
    return $state.records.find(record => record.id === Number(id));
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

export const actions = {
  get: async ({ commit }) => {
    commit(types.SET_BOT_FLOWS_UI_FLAG, { isFetching: true });
    try {
      const response = await BotFlowsAPI.get();
      commit(types.SET_BOT_FLOWS, response.data.payload);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_BOT_FLOWS_UI_FLAG, { isFetching: false });
    }
  },
  show: async ({ commit }, id) => {
    commit(types.SET_BOT_FLOWS_UI_FLAG, { isFetchingItem: true });
    try {
      const response = await BotFlowsAPI.show(id);
      commit(types.ADD_BOT_FLOW, response.data);
      return response.data;
    } finally {
      commit(types.SET_BOT_FLOWS_UI_FLAG, { isFetchingItem: false });
    }
  },
  create: async ({ commit }, botFlowObj) => {
    commit(types.SET_BOT_FLOWS_UI_FLAG, { isCreating: true });
    try {
      const response = await BotFlowsAPI.create(botFlowObj);
      commit(types.ADD_BOT_FLOW, response.data);
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    } finally {
      commit(types.SET_BOT_FLOWS_UI_FLAG, { isCreating: false });
    }
  },
  update: async ({ commit }, { id, ...updateObj }) => {
    commit(types.SET_BOT_FLOWS_UI_FLAG, { isUpdating: true });
    try {
      const response = await BotFlowsAPI.update(id, updateObj);
      commit(types.EDIT_BOT_FLOW, response.data);
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    } finally {
      commit(types.SET_BOT_FLOWS_UI_FLAG, { isUpdating: false });
    }
  },
  activate: async ({ commit }, id) => {
    commit(types.SET_BOT_FLOWS_UI_FLAG, { isActivating: true });
    try {
      const response = await BotFlowsAPI.activate(id);
      commit(types.EDIT_BOT_FLOW, response.data);
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    } finally {
      commit(types.SET_BOT_FLOWS_UI_FLAG, { isActivating: false });
    }
  },
  delete: async ({ commit }, id) => {
    commit(types.SET_BOT_FLOWS_UI_FLAG, { isDeleting: true });
    try {
      await BotFlowsAPI.delete(id);
      commit(types.DELETE_BOT_FLOW, id);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_BOT_FLOWS_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_BOT_FLOWS_UI_FLAG]($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  [types.SET_BOT_FLOWS]: MutationHelpers.set,
  [types.ADD_BOT_FLOW]: MutationHelpers.setSingleRecord,
  [types.EDIT_BOT_FLOW]: MutationHelpers.update,
  [types.DELETE_BOT_FLOW]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
